export const uk = {
    recommendation: 'Рекомендации'
};
